import { Feather } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/content";

const EditorialMarquee = () => {
    const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div
            data-testid="editorial-marquee"
            className="relative overflow-hidden border-y border-[#D9A441]/25 bg-[#0A0D16] py-6"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center">
                                <span className="whitespace-nowrap px-10 font-display text-lg font-semibold uppercase tracking-[0.3em] text-[#F8F5EE]/25 sm:text-xl">
                                    {item}
                                </span>
                                <Feather className="h-4 w-4 shrink-0 text-[#D9A441]/50" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EditorialMarquee;
